import { render } from "./branches_component.vue?vue&type=template&id=03f65e2e&scoped=true"
import script from "./branches_component.vue?vue&type=script&lang=js"
export * from "./branches_component.vue?vue&type=script&lang=js"

import "./branches_component.vue?vue&type=style&index=0&id=03f65e2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f65e2e"]])

export default __exports__